// extracted by mini-css-extract-plugin
export default {"wrapper":"s5Hjw","content":"DAsXL","icon":"ba9qX"};